<div>
  <ion-select
    label="Monat"
    mode="md"
    label-placement="floating"
    fill="outline"
    (ionChange)="selectedValueChanged.emit($event.detail.value)"
    [multiple]="multiple"
    [value]="preselectedMonth"
    interface="popover"
  >
    <ion-select-option *ngIf="showAllEntry" [value]="null"
      >Alle Monate</ion-select-option
    >
    <ion-select-option
      *ngFor="let value of this.values"
      [value]="this.values.indexOf(value)"
      >{{ value }}</ion-select-option
    >
  </ion-select>
  <ion-select
    style="width: 125px; margin-left: 5px"
    label="Jahr"
    mode="md"
    label-placement="floating"
    fill="outline"
    (ionChange)="selectedYearChanged.emit($event.detail.value)"
    [value]="preselectedYear"
    interface="popover"
  >
    <ion-select-option [value]="value" *ngFor="let value of this.years">{{
      value
    }}</ion-select-option>
  </ion-select>
</div>
